/**
 * 주 라벨과 짧은 뜻풀이를 두 요소로 나눠 세운다(2026-10-14 사용자 지시).
 *
 * 전에는 라벨과 뜻풀이를 대시 하나로 이어 한 덩어리 글자로 썼다(예: 개시순 대시 먼저 여는 순서).
 * 둘이 같은 크기와 굵기라 어디까지가 이름이고 어디부터가 풀이인지가 기호 하나에만 실렸다.
 * 지금은 라벨이 바깥 글자 모양을 그대로 받고, 뜻풀이는 한 단계 작고 가늘고 흐린 글자로 곁에 선다.
 * 배지나 상자는 두지 않는다(사용자: 불필요한 배지와 상자를 더하지 않는다).
 *
 * 두 가지 배치가 있다.
 * 1. 곁에(기본): 같은 줄에 라벨, 간격, 뜻풀이. 폭이 모자라면 뜻풀이가 다음 줄로 내려간다. 제목과 범례가 쓴다.
 * 2. 아래에(stack): 라벨 아래에 뜻풀이. 폭을 나눠 가지는 분절 칸(정렬 두 칸)이 쓴다. 360 폭의 칸 안 폭이
 *    약 140px 이라 한 줄로 이으면 칸마다 글자가 접혔다.
 *
 * 두 요소 사이에 공백 글자를 하나 둔다. 화면 읽개와 글자 검사가 「개시순먼저 여는 순서」처럼 붙여 읽지 않게 한다.
 */
export function LabelHint(props: {
  label: string
  hint: string
  stack?: boolean
  /** 뜻풀이의 글자 모양. 기본은 12px 보통 굵기 ink-dim. 바깥이 이미 12px 이면 색만 한 칸 내린다. */
  hintClassName?: string
  hintTestId?: string
}): React.ReactElement {
  const hintClass = props.hintClassName ?? 'text-xs font-normal text-ink-dim'
  if (props.stack === true) {
    return (
      <span className="flex min-w-0 flex-col items-center">
        <span>{props.label}</span>{' '}
        <span data-testid={props.hintTestId} className={hintClass}>
          {props.hint}
        </span>
      </span>
    )
  }
  return (
    <span className="flex min-w-0 flex-wrap items-baseline gap-x-2">
      <span>{props.label}</span>{' '}
      <span data-testid={props.hintTestId} className={hintClass}>
        {props.hint}
      </span>
    </span>
  )
}
